export const PendingReason = {
  store_operation: '店舗操作',
  delivery_service: 'デリバリーサービス',
  pos_healthcheck_failure: 'POSヘルスチェック失敗',
} as const;
export type PendingReason = keyof typeof PendingReason;
